import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

export const useConfirmICSOrderList = () => {
  const mutate = useMutation(
    ({
      warehouseOrderIds,
      bulkSlipNo,
    }: {
      warehouseOrderIds: any[]
      bulkSlipNo: any
    }) => {
      const iCSBulkSlipOrders = warehouseOrderIds.map((order: any) => ({
        warehouseOrderId: order.id, // Assuming ID in `selectedRowIds` is `WarehouseOrderId`
        orderNo: order.orderNo || '', // Fallback in case `orderNo` is missing
        principle: order.partnerOrder?.partner?.name || '',
        bulkSlipNo: bulkSlipNo,
        defaultCarrierName: order.partnerOrder?.defaultCarrierName || '',
        carrierServiceProduct: order.partnerOrder?.carrierProduct || '',
        //consNo: order.consNo || '',
      }))

      return postAPI(`ICSBulkConsignment/ConfirmICSOrders`, {
        iCSBulkSlipOrders,
      })
    },
  )

  return mutate
}

export default useConfirmICSOrderList
